<template>
  <v-snackbar class="text-center" v-model="show" :color="color">
    {{ message }}
  </v-snackbar>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      message: '',
      color: ''
    };
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'SET_MESSAGE') {
        this.message = state.snackbar.content;
        this.color = state.snackbar.color;
        this.show = true;
      }
    });
  }
};
</script>
